import { Routes, Route } from '@angular/router';

import { AuthComponent } from '../containers/auth/auth.component';

export const AuthShell = {
  /**
   * Creates routes using the auth shell component.
   *
   * @param routes The routes to add.
   * @return The new route using shell auth as the base.
   */
  childRoutes(routes: Routes): Route {
    return {
      path: '',
      component: AuthComponent,
      children: routes,
    };
  },
};
